import { ReactNode } from 'react';
import { Box, Text, Button } from '@mantine/core';
import { isBagelAdmin } from '../utils';
import { useCurrentUser } from '../hooks/useCurrentUser';

interface BagelAdminProtectedRouteProps {
  children: ReactNode;
}

export const BagelAdminProtectedRoute = ({ children }: BagelAdminProtectedRouteProps): JSX.Element => {
  const user = useCurrentUser();

  if (!isBagelAdmin(user)) {
    return (
      <Box p="xl" ta="center">
        <Text size="xl" fw={600} mb="md">Access Denied</Text>
        <Text color="dimmed" mb="lg">
          You don&apos;t have permission to access this page. This page is restricted to Bagel admins.
        </Text>
        <Button onClick={() => window.history.back()}>
          Go Back
        </Button>
      </Box>
    );
  }

  return <>{children}</>;
};
